<!-- <div class="dropdown context-menu" id="context-menu-{{ $index }}"> -->
<div class="dropdown context-menu">
    <ul class="dropdown-menu" role="menu">
      <li>
        <!-- ios change -->
        <a class="pointer" role="menuitem" ng-hide='device.platform == "iOS" || device.platform === "tvOS"' ng-click="control.back(); $event.preventDefault()">
          <i class="fa fa-mail-reply fa-fw"></i>
          <span>{{"Back" | translate}}</span>
        </a>
        <!-- ios change -->
      </li>
      <li>
        <a class="pointer" role="menuitem" ng-click="control.home(); $event.preventDefault()">
          <i class="fa fa-home fa-fw"></i>
          <span>{{"Home" | translate}}</span>
        </a>
      </li>
      <li>
        <!-- ios change -->
        <a class="pointer" role="menuitem" ng-hide='device.platform == "iOS" || device.platform === "tvOS"' ng-click="control.appSwitch(); $event.preventDefault()">
          <i class="fa fa-square-o fa-fw"></i>
          <span>{{"Recents" | translate}}</span>
        </a>
        <!-- ios change -->
      </li>
      <li class="divider"></li>
      <li>
        <a class="pointer" role="menuitem" ng-click="rotateRight(); $event.preventDefault()">
          <i class="fa fa-rotate-left fa-fw"></i>
          <span>{{"Rotate Left" | translate}}</span>
        </a>
      </li>
      <li>
        <a class="pointer" role="menuitem" ng-click="rotateLeft(); $event.preventDefault()">
          <i class="fa fa-rotate-right fa-fw"></i>
          <span>{{"Rotate Right" | translate}}</span>
        </a>
      </li>
      <li class="divider"></li>
      <li>
        <a class="pointer" role="menuitem" ng-click="saveScreenShot(); $event.preventDefault()">
          <i class="fa fa-camera fa-fw"></i>
          <span>{{"Save ScreenShot" | translate}}</span>
        </a>
      </li>
      <li class="divider"></li>
      <li>
        <a class="pointer" role="menuitem" ng-click="$root.standalone ? windowClose() : kickDevice(device); $event.preventDefault()">
          <i class="fa fa-sign-out fa-fw"></i>
          <span>{{"Stop Using" | translate}}</span>
        </a>
      </li>
    </ul>
</div>
<!-- prev style style="height:93vh; top: 0.5vh; width: 70%; left: 16%;" -->
<div class="body" style="height:90vh;">
  <ng-content></ng-content>
</div> 
  
<!-- <div class="stf-device-context-menu" ng-transclude context-menu data-target="context-menu-{{ $index }}"></div> -->
<div class="stf-device-context-menu"></div>
  